import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentModalService {
  // Observable sources
  private documentContentSource = new BehaviorSubject<any>(null);
  private showModalSource = new BehaviorSubject<boolean>(false);

  // Observable streams
  documentContent$ = this.documentContentSource.asObservable();
  showModal$ = this.showModalSource.asObservable();

  constructor() { }

  /**
   * Show the document modal with content
   * @param content Document content object with title and text
   */
  showDocumentModal(content: any) {
    this.documentContentSource.next(content);
    this.showModalSource.next(true);
  }

  /**
   * Hide the document modal
   */
  hideDocumentModal() {
    this.showModalSource.next(false);
  }
} 